import React from 'react';
// generics
import * as S from '../../styles';

export default function THeader({ headerLabels }: any) {

  return (
    <div className="header">
      {headerLabels.map((cell: any, i: number) => (
        <S.Cell className={`${cell.key} header-height`} key={i}>
          <p>
            {cell.label}
          </p>
        </S.Cell>
      ))}
    </div>
  );
}
